module.exports = __webpack_public_path__ + "img/50.2d2d9bb9.png";